import type { Option } from '@ksyos/design-system';
import { Koi } from '@ksyos/koi';
import type { ISchemaContainer } from './schemaContainer';
import type { ServiceChoice } from './schemas/choiceSchema';
import { serviceChoiceSchema } from './schemas/choiceSchema';
import { positiveInt32Schema } from './schemas/positiveInt32Schema';

export interface IPaymentExportValidated {
    batchId: string | null;
    bookYear: number | null;
    endDate: string | null;
    expectedPayoutDate: string | null;
    isPreview?: boolean;
    monthChoice: string | null;
    serviceChoice: ServiceChoice;
    serviceId?: string;
    serviceProvider: Option | null;
    startDate: string | null;
}

export const paymentExportSchema: ISchemaContainer<IPaymentExportValidated> = {
    schema: Koi.alternatives()
        .try(
            Koi.object({
                batchId: Koi.string().uuid(),
                bookYear: positiveInt32Schema.allow(null),
                endDate: Koi.koi().endDate().date().allow(null),
                expectedPayoutDate: Koi.koi().date().allow(null),
                isPreview: Koi.boolean(),
                sentBeforeDate: Koi.koi().date().allow(null),
                serviceChoice: serviceChoiceSchema,
                serviceId: Koi.string().uuid().allow(null),
                serviceProvider: Koi.object({
                    label: Koi.string().required(),
                    value: Koi.string().required(),
                }).allow(null),
                startDate: Koi.koi().date().allow(null),
            }),
            Koi.object({
                batchId: Koi.string().uuid().allow(null),
                bookYear: positiveInt32Schema,
                endDate: Koi.koi().endDate().date(),
                episodeCategoryId: Koi.string().uuid(),
                expectedPayoutDate: Koi.koi().date(),
                isPreview: Koi.boolean(),
                sentBeforeDate: Koi.koi().date(),
                serviceChoice: serviceChoiceSchema,
                serviceId: Koi.when('serviceChoice', {
                    is: 'specific',
                    otherwise: Koi.string().uuid().allow(null),
                    then: Koi.string().uuid(),
                }),
                serviceProvider: Koi.object({
                    label: Koi.string().required(),
                    value: Koi.string().required(),
                }).allow(null),
                startDate: Koi.koi().date(),
            })
        )
        .options({ convert: false, presence: 'required' }),
};
